/** The `shell` area: the app shell: the sidebar, the top bar, the dock, the
 *  profile menu, the trail, loading and error screens. Owned by the stage 2
 *  slot components-a (docs/I18N.md §11). */
export const shell = {
  'shell.brand.name': 'Tesserano',
  'shell.brand.home': 'Tesserano home',
  /** The page description (the root layout's metadata) and the web app
   *  manifest's; the app's name stays Tesserano in every language. */
  'shell.brand.description': 'An x-ray for organisations: the graph of who needs what from whom.',
  // The pages the sidebar, the dock, the palette and the loading chrome name.
  'shell.page.activity': 'Activity',
  'shell.page.work': 'Work',
  'shell.page.map': 'Map',
  'shell.page.tags': 'Tags',
  'shell.page.groups': 'Groups',
  'shell.page.flowPhases': 'Stages',
  'shell.page.flows': 'Flows',
  'shell.page.plans': 'Plans',
  'shell.page.ceremonies': 'Ceremonies',
  'shell.page.search': 'Search',
  'shell.page.views': 'Boards',
  'shell.page.lenses': 'Views',
  'shell.page.account': 'Account',
  'shell.page.contacts': 'Contacts',
  'shell.page.admin': 'Admin',
  'shell.page.design': 'Design',
  // An item's sections, as their screens name them.
  'shell.section.activity': 'Activity',
  'shell.section.relationships': 'Relationships',
  'shell.section.proposed': 'Proposed changes',
  'shell.section.description': 'Description',
  'shell.section.files': 'Files',
  'shell.section.details': 'Details',
  // The sidebar and the dock.
  'shell.nav.primary': 'Primary',
  'shell.nav.unread': { one: '{count} unread', other: '{count} unread' },
  'shell.nav.pinned': 'Pinned',
  'shell.nav.allLenses': 'All views',
  'shell.nav.allViews': 'All boards',
  'shell.nav.newLens': 'New view',
  'shell.nav.newView': 'New board',
  'shell.nav.newTask': 'New item',
  'shell.nav.showMore': { one: 'Show {count} more', other: 'Show {count} more' },
  'shell.nav.showLess': 'Show less',
  'shell.nav.sortLenses': 'Sort views',
  'shell.nav.sortViews': 'Sort boards',
  'shell.nav.sortLensesBy': 'Sort views ({sort})',
  'shell.nav.sortViewsBy': 'Sort boards ({sort})',
  'shell.nav.sortBy': 'Sort by',
  /** A view's scope in the palette when its group's name is not at hand. */
  'shell.viewsSort.viewed': 'Last viewed',
  'shell.viewsSort.recent': 'Recently added',
  'shell.viewsSort.changed': 'Recently changed',
  'shell.viewsSort.type': 'By type',
  'shell.viewsSort.alpha': 'Alphabetical',
  'shell.sidebar.expand': 'Expand sidebar',
  'shell.sidebar.collapse': 'Collapse sidebar',
  'shell.sidebar.expandShort': 'Expand',
  'shell.sidebar.collapseShort': 'Collapse',
  'shell.topbar.search': 'Search (Ctrl+O)',
  'shell.newItem.title': 'New item',
  // The profile menu.
  'shell.profile.menu': 'Profile menu',
  'shell.profile.sheet': 'Profile',
  'shell.profile.appearance': 'Appearance',
  'shell.profile.signOut': 'Sign out',
  'shell.profile.signInAs': 'Persona',
  /** The dev persona menu's caption: the roster is for testing only. */
  'shell.profile.testing': 'Testing',
  /** A handle as the head shows it, under the name. */
  'shell.profile.handle': '@{handle}',
  'shell.theme.light': 'Light',
  'shell.theme.auto': 'Auto',
  'shell.theme.dark': 'Dark',
  // Worn override mode, the line under the profile menu's head.
  'shell.elevate.until': 'Override mode · until {time}',
  'shell.elevate.end': 'End',
  // The offline queue's count in the top bar.
  'shell.queue.full': 'Too many changes are waiting to sync. Reconnect before acting again.',
  'shell.queue.offline': 'Changes taken offline, waiting for a connection.',
  /** The word after the count; the count itself is its own element. */
  'shell.queue.waiting': { one: 'waiting', other: 'waiting' },
  // The trail.
  'shell.trail.label': 'Path',
  'shell.trail.back': 'Back',
  'shell.trail.backOneStep': 'Back one step',
  'shell.trail.hiddenSteps': 'Hidden steps',
  'shell.trail.showHidden': 'Show hidden steps',
  'shell.trail.more': { one: '{count} more', other: '{count} more' },
  // Loading, and the error state in a skeleton's layout.
  'shell.loading.label': 'Loading',
  'shell.loading.back': 'Back',
  'shell.loading.aboutItem': 'About this item',
  'shell.loading.nextStep': 'Next step',
  'shell.skeleton.titleColumn': 'Title',
  'shell.skeleton.activityDetail': 'Open an entry to read its detail here.',
  'shell.loadError.title': 'Not loaded',
  'shell.loadError.offlineItem': 'Offline. This item was not loaded.',
  'shell.loadError.offlinePage': 'Offline. This page was not loaded.',
  'shell.loadError.item': 'This item could not be loaded.',
  'shell.loadError.page': 'This page could not be loaded.',
  'shell.loadError.retry': 'Retry',
  'shell.loadError.back': 'Back',
  /** A change the offline queue replayed and the server refused, with no
   *  reason of its own. */
  'shell.queue.refused': 'This change was refused.',
  /** The trail's root crumb when it needs no read to name it (src/lib/trail.ts). */
  'shell.trail.root.work': 'Work',
  'shell.trail.root.search': 'Search',
} as const;
